import React, { useEffect, useState } from "react";
import {
    Stack,
    Box,
    Text,
    SimpleGrid,
    Divider,
} from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const EditLoyaltyConfigDrawer = ({ isOpen, onClose, config, onUpdate }) => {
    const [formData, setFormData] = useState({});

    useEffect(() => {
        if (config) setFormData(config);
    }, [config]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: Number(value),
        }));
    };

    const handleSubmit = () => {
        onUpdate(formData);
        onClose();
    };


    const formatLabel = (key) =>
        key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());


    const coreFields = [
        "points_per_pula",
        "referral_percentage",
        "min_points",
        "max_points",
        "driver_referral_base",
    ];

    const tierFields = [
        "bronze_threshold",
        "silver_threshold",
        "gold_threshold",
        "platinum_threshold",
    ];

    const multiplierFields = [
        "bronze_multiplier",
        "silver_multiplier",
        "gold_multiplier",
        "platinum_multiplier",
    ];

    const renderGroup = (title, fields) => (
        <Box>
            <Text fontSize="md" fontWeight="bold" mb={3}>
                {title}
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                {fields.map((key) => (
                    <ReusableInput
                        key={key}
                        label={formatLabel(key)}
                        name={key}
                        value={formData[key] ?? ""}
                        onChange={handleChange}
                        type="number"
                    />
                ))}
            </SimpleGrid>
        </Box>
    );

    return (
        <ReusableDrawer
            isOpen={isOpen}
            onClose={onClose}
            headerContent={<h2>Edit Loyalty Config</h2>}
            bodyContent={
                <Stack spacing={6}>
                    <Box>
                        <Text fontSize="lg" fontWeight="bold">
                            Configuration Settings
                        </Text>
                        <Divider mt={2} />
                    </Box>
                    {renderGroup("Core Settings", coreFields)}
                    {renderGroup("Tier Thresholds", tierFields)}
                    {renderGroup("Tier Multipliers", multiplierFields)}
                </Stack>
            }
            footerContent={
                <Stack direction="row" justify="flex-end">
                    <GradientButton onClick={onClose} width="140px"
                        height="36px"
                        fontSize="13px">
                        Cancel
                    </GradientButton>
                    <GradientButton onClick={handleSubmit} width="140px"
                        height="36px"
                        fontSize="13px">
                        Update
                    </GradientButton>
                </Stack>
            }
        />
    );
};

export default EditLoyaltyConfigDrawer;